import React from "react";
import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { PlatformOverview } from "../components/PlatformOverview";
import { CarExplainer } from "../components/CarExplainer";
import { OperatingModel } from "../components/OperatingModel";
import { WhatKatlasChanges } from "../components/WhatKatlasChanges";
import { BoundedAi } from "../components/BoundedAi";
import { JourneyStorybooks } from "../components/JourneyStorybooks";
import { WhatYouLeaveWith } from "../components/WhatYouLeaveWith";
import { ChooseYourNextStep } from "../components/ChooseYourNextStep";
import { QuietContactCta } from "../components/QuietContactCta";
import { Footer } from "../components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#020B14] text-white antialiased" id="top">
      <Nav />
      <main>
        <Hero />
        <PlatformOverview />
        <CarExplainer />
        <OperatingModel />
        <WhatKatlasChanges />
        <BoundedAi />
        <JourneyStorybooks />
        <WhatYouLeaveWith />
        <ChooseYourNextStep />
        <QuietContactCta />
      </main>
      <Footer />
    </div>
  );
}
